import * as Sentry from "@sentry/react";

/**
 * Sentry DSN — a public ingest key, safe to ship in the bundle. Hardcoded
 * so it survives CI rebuilds; `VITE_SENTRY_DSN` can override it. Errors +
 * traces flow to the `vihangam-yog-nz-website-production` project.
 */
const DSN =
  import.meta.env.VITE_SENTRY_DSN ||
  "https://7fada74cabdf030ef3444b312f8c54e9@o4507009979645952.ingest.us.sentry.io/4511732909932544";

/** The VY backend Worker — spans that call it continue the same trace. */
const BACKEND_ORIGIN = /vy-australia-backend\.kishek12\.workers\.dev/;

export function initSentry(): void {
  if (!DSN) {
    return;
  }
  Sentry.init({
    dsn: DSN,
    environment: import.meta.env.MODE,
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: 1.0,
    tracePropagationTargets: ["localhost", BACKEND_ORIGIN],
    sendDefaultPii: false,
  });

  // Visit any page with `?debug-sentry` to fire a captured test event.
  if (new URLSearchParams(window.location.search).has("debug-sentry")) {
    Sentry.captureException(new Error("VY NZ web Sentry test error"));
  }
}
